<template>
  <div>
    <span class="text-h5 font-weight-light d-block">{{ resource.title }}</span>
    <v-list>
      <div v-for="(doc, index) in documentDetails" :key="doc.documentId">
        <v-list-item>
          <v-list-item-content>
            {{ doc.docReference }}
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon :disabled="imageLoading" @click="viewDocument(doc)">
              <v-icon v-if="!imageLoading" large :color="primaryColor">mdi-eye</v-icon>
              <v-progress-circular v-else indeterminate size="24" width="4" :color="primaryColor" />
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider v-if="index < documentDetails.length - 1" />
      </div>
    </v-list>

    <PDFPreview
      v-if="showPdfPreview"
      :PDFData="selectedDocument.data"
      :config=" { width: '80%', title: resource.preview, btn1Label: resource.close }"
      @closePdfPreview="showPdfPreview = false"
      show-close-btn
    >
      <template v-slot:modalHeaderContent>
        <span class="text-h6 text--secondary d-block ml-2">
          {{ selectedDocument.docReference }}
        </span>
      </template>
    </PDFPreview>

    <Modal :config="modalConfig">
      <template v-slot:modalContent>
        <span class="text-h6 text--secondary d-block">
          {{ selectedDocument.docReference }}
        </span>
        <v-card rounded="xl" outlined class="d-flex justify-center align-center pa-4 mt-4">
          <v-avatar height="600" width="600">
            <img :src="selectedDocument.data" />
          </v-avatar>
        </v-card>
      </template>
    </Modal>
  </div>
</template>

<script>
import commonService from '../../service/commonService'

export default {
  name: 'PayeeRelatedDocuments',
  props: {
    documentDetails: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      imageLoading: true,
      documents: [],
      selectedDocument: '',
      showPdfPreview: false,
      modalConfig: {
        enabled: false,
        width: '60%'
      }
    }
  },
  components: {
    PDFPreview: () => import('@/components/common/PDFPreview.vue'),
    Modal: () => import('@/components/common/Modal.vue')
  },
  async created () {
    this.documents = await Promise.all(
      this.documentDetails.map(async doc => {
        const docResp = await commonService.getSupplementaryDocument(doc.documentId)
        const { data = '', contentType = '' } = docResp || {}
        return {
          documentId: doc.documentId,
          docReference: doc.docReference,
          contentType,
          data
        }
      })
    )
    this.imageLoading = false
  },
  methods: {
    viewDocument (doc) {
      this.selectedDocument = this.documents.find(i => i.documentId === doc.documentId)
      this.selectedDocument = { ...this.selectedDocument, doc }
      const isPdf = this.selectedDocument.contentType.includes('application/pdf')

      if (isPdf) {
        this.showPdfPreview = true
        return
      }
      this.modalConfig.enabled = true
      this.modalConfig.title = this.resource.preview
      this.modalConfig.btn1Label = this.resource.close
    }
  },
  computed: {
    resource () {
      return {
        title: this.$t('payeeRelatedDocuments.title'),
        close: this.$t('payeeRelatedDocuments.closeBtnLabel'),
        preview: this.$t('payeeRelatedDocuments.previewDocument')
      }
    }
  }
}
</script>
